import moment from 'moment';
import 'moment/locale/en-gb';

const workingHoursPerday = 8;

export function getMissionRecordAmountOfDays(from, to) {
	let totalHours = 0;
	const start = moment(from);
	const end = moment(to);
	const current = start.clone().startOf('day');
	let excludedHolidays = [];
	while (current.isSameOrBefore(end, 'day')) {
		const workStart = current.clone().hour(8).minute(0).second(0);
		const workEnd = current.clone().hour(16).minute(0).second(0);
		const effectiveStart = moment.max(workStart, start);
		const effectiveEnd = moment.min(workEnd, end);
		if (effectiveEnd.isAfter(effectiveStart)) {
			totalHours += effectiveEnd.diff(effectiveStart, 'hours', true);
		}

		current.add(1, 'day');
	}
	return { count: totalHours / workingHoursPerday, excludedHolidays };
}
